/**
 * Format a $mm figure the way v1's snapshot writer does, so a v1↔v2 side-by-side reads as a real
 * comparison rather than a formatting diff.
 *
 * The rule is copied deliberately from `affinity_sync._format_money`:
 *
 *   f"${int(val)}M"   when the value is integral   →  120.0  → "$120M"
 *   f"${val:.1f}M"    otherwise                    →  14.55  → "$14.6M"
 *
 * Note the one-decimal rounding is v1's own precision loss — 14.55 really is stored as "$14.6M".
 * v2 keeps the full-precision number and only rounds at render, which is why the parity harness
 * compares with a 0.05 tolerance instead of on strings.
 */
export function formatMoneyMm(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return Number.isInteger(value) ? `$${value}M` : `$${value.toFixed(1)}M`;
}
